<template>
  <div id="themeDetail">
    <v-layout wrap row>
      <v-flex md6 pb-4 mt-1 style="min-height:70px;">
        <v-btn fab left @click="backToListing" class="pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 mt-3> 
        <div style="float:right" v-if="dataChanged && !(Account.template && Account.template.template)">
          <v-btn @click="cancelSelect" class="pf-btn pf-btn-cancel">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="saveTemplate">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
        <div style="float:right" v-if="Account.template && Account.template.template">
        <v-btn @click="resetSelect" class="pf-btn pf-btn-cancel">
          <v-icon size="16" class="pr-1">refresh</v-icon>
          <div>Reset</div>
        </v-btn>
      </div>
      </v-flex>
    </v-layout>
    <v-layout wrap row>
      <v-flex md9 pr-4>
        <v-layout wrap row>
          <v-flex xs12>
            <v-carousel 
              hide-delimiters
              :cycle="false"
              :value="slideIndex"
              @change="slideChange"
              :height="slideHeight"
              class="slide-box templateSlider"
              ref="slideBox"
            >
              <v-carousel-item
                v-for="(page, i) in templateItem.page"
                :key="i"
                :src="`${config.uploadPath}` + page.webPath"
              ></v-carousel-item>
            </v-carousel>
          </v-flex>
          <v-flex xs12 pt-2 fixed-height-100>
            <v-tabs
              show-arrows
              class="slider-tab"
              ref="tabs"
            >
              <v-tab
                v-for="(page, i) in templateItem.page"
                :key="i"
                @click="slideChange(i)"
                :value="slideIndex"
              >
                <v-card flat tile class="d-inline-flex pa-1"
                  width="100%"
                  :class="{'pf-bg-green': slideIndex === i}"
                >
                  <img
                    :src="`${config.uploadPath}` + page.webPath"
                    class="grey lighten-2"
                    contain
                    height="100%"
                    width="100%"
                  >
                </v-card>
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-flex xs12 pt-4>
            <div class="pf-sub-head">Description</div>
            <p class="pt-2 pf-text-default">{{ templateItem.description ? stripTags(templateItem.description) : '---' }}</p>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex md3>
        <v-btn block class="pf-btn button_background " sm12 :href="templateItem.demo_url" target="_blank">
          <v-icon size="16" class="pr-2 left_icon">menu_book</v-icon>
          <div class="mid_heading">Demo Flipbook</div>
          <v-icon size="16" class="right_icon" right>arrow_right</v-icon>
        </v-btn>
        <v-btn block class="pf-btn button_background" @click="customizeColor = !customizeColor">
          <v-icon size="15" class="pr-2 left_icon">fas fa-swatchbook</v-icon>
          <div class="mid_heading">Customize colors</div>
          <v-icon size="15" class="right_icon">fas fa-question-circle</v-icon>
        </v-btn>
        <v-layout wrap row pt-3 v-if="customizeColor">
        <v-flex xs12 sm12 class="pr-2">
          <span class="pf-menu-text">Front Cover</span>
        </v-flex>
          <v-flex xs12 sm12 v-if="!(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.front_cover" @click="pickFrontColor = !pickFrontColor" class="picker_button"></v-btn>
          <chrome-picker :value="templateItem.style.front_cover" @input="changePrimaryColor" width="175px" v-if="pickFrontColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm12 v-if="(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.front_cover" class="picker_button"></v-btn>
        </v-flex>

        <v-flex xs12 sm12 class="pr-2 pt-2">
          <span class="pf-menu-text">Background Cover</span>
        </v-flex>
          <v-flex xs12 sm12 v-if="!(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.background_cover" @click="pickBackgroundColor = !pickBackgroundColor" class="picker_button"></v-btn>
          <chrome-picker :value="templateItem.style.background_cover" @input="changeBackgroundColor" v-if="pickBackgroundColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm12 v-if="(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.background_cover" class="picker_button"></v-btn>
        </v-flex>

        <v-flex xs12 sm12 class="pr-2 pt-2">
          <span class="pf-menu-text">Borders</span>
        </v-flex>
        <v-flex xs12 sm12 v-if="!(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.border" @click="pickBorderColor = !pickBorderColor" class="picker_button"></v-btn>
          <chrome-picker :value="templateItem.style.border" @input="changeBorderColor" v-if="pickBorderColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm12 v-if="(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.border" class="picker_button"></v-btn>
        </v-flex>

        <v-flex xs12 sm12 class="pr-2 pt-2">
          <span class="pf-menu-text">Title Headings</span>
        </v-flex>
          <v-flex xs12 sm12 v-if="!(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.title_heading" @click="pickHeadingColor = !pickHeadingColor" class="picker_button"></v-btn>
          <chrome-picker :value="templateItem.style.title_heading" @input="changeHeadingColor" v-if="pickHeadingColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm12 v-if="Account.template && Account.template.template">
          <v-btn depressed block :color="templateItem.style.title_heading" class="picker_button"></v-btn>
        </v-flex>

        <v-flex xs12 sm12 class="pr-2 pt-2">
          <span class="pf-menu-text">Border Around Photos</span>
        </v-flex>
          <v-flex xs12 sm12 v-if="!(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.photo_border" @click="pickBorderAroundColor = !pickBorderAroundColor" class="picker_button"></v-btn>
          <chrome-picker :value="templateItem.style.photo_border" @input="changeBorderAroundColor" v-if="pickBorderAroundColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm12 v-if="(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.photo_border" class="picker_button"></v-btn>
        </v-flex>

        <v-flex xs12 sm12 class="pr-2 pt-2">
          <span class="pf-menu-text">Inside Background Colors</span>
        </v-flex>
          <v-flex xs12 sm12 v-if="!(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.insidebackground_color" @click="pickInsideBackgroundColor = !pickInsideBackgroundColor" class="picker_button"></v-btn>
          <chrome-picker :value="templateItem.style.insidebackground_color" @input="changeinsideBackgroundColor" v-if="pickInsideBackgroundColor"></chrome-picker>
        </v-flex>
        <v-flex xs12 sm12 v-if="(Account.template && Account.template.template)">
          <v-btn depressed block :color="templateItem.style.insidebackground_color" class="picker_button"></v-btn>
        </v-flex>

        <a href="https://www.design-seeds.com/by-color/" class="pt-3 color_ideas" target="_blank">Color Ideas</a>
        </v-layout>
        
        <!-- <div class="pf-sub-head">Description</div>
        <p class="pt-2 pf-text-default">{{ templateItem.description ? stripTags(templateItem.description) : '---' }}</p>
        <div class="pf-sub-head mb-2"><b>Options</b></div>
        <v-divider></v-divider>
        <v-divider></v-divider>
        <v-divider></v-divider> -->
        <!-- <div class="pf-sub-head mt-3">Color Variants</div>
        <v-flex md12 pt-4 pb-4>
          <span
            :style="'cursor:pointer;'"
            v-for="(style, j) in templateItem.style"
            :key="style.id"
            class="pr-2"
            @dblclick="counter += 1, colorSelectDailog(`${config.uploadPath}${style.webPath}`)"
            @click="colorSelect(j)"
          >
            <img
              :src="`${config.uploadPath}` + style.webPath"
              :alt="style.name"
              height="120px"
              :class="{'selected_border': j == colorIndex}"
              class="default_border"
            />
          </span>
        </v-flex> -->
      </v-flex>
    </v-layout>
    <v-flex md12 pt-4 pb-4 style="min-height:70px;">
      <div style="float:right" v-if="dataChanged && !(Account.template && Account.template.template)">
        <v-btn @click="cancelSelect" class="pf-btn pf-btn-cancel">
          <v-icon size="16" class="pr-1">cancel</v-icon>
          <div>Cancel</div>
        </v-btn>
        <v-btn class="pf-btn pf-btn-save" @click="saveTemplate">
          <v-icon size="16" class="pr-1">check_circle</v-icon>
          <div>Save</div>
        </v-btn>
      </div>
      <div style="float:right" v-if="Account.template && Account.template.template">
        <v-btn @click="resetSelect" class="pf-btn pf-btn-cancel">
          <v-icon size="16" class="pr-1">refresh</v-icon>
          <div>Reset</div>
        </v-btn>
      </div>
    </v-flex>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" class="text-xs-center" max-width="400">
      <v-layout wrap>
        <v-card>
           <v-card-actions class="text-xs-right">
          <v-spacer></v-spacer>
            <v-icon @click="dialog=!dialog" size="32" color="#f195bf" class="pr-1">cancel</v-icon>
        </v-card-actions>
          <img
            class="image_class"
            :src="DialogImg"
            height="100%"
            width="100%"
          />
        </v-card>
    </v-layout>
    </v-dialog>
    </v-layout>
  </div>
</template>
<script>
/* global session store config */
import { getOne, update, create } from '../../helpers/helpers';
import swal from 'sweetalert2';
import { Chrome } from 'vue-color';
export default {
  components: {
    'chrome-picker': Chrome,
  },
  data: () => ({
    config: config,
    counter: 0,
    dialog: false,
    DialogImg: '',
    dataChanged: true,
    slideIndex: 0,
    slideHeight: 500,
    colorIndex: 0,
    activePage: 0,
    largeImagename: '',
    largeImagesrc: '',
    templateId: '',
    pickFrontColor: false,
    pickBackgroundColor: false,
    pickHeadingColor: false,
    pickBorderColor: false,
    pickInsideBackgroundColor: false,
    pickBorderAroundColor: false,
    customizeColor: false,
    templateItem: {},
    defaultTemplateItem: {
      style: {
        'front_cover': '#7AC142',
        'background_cover': '#F195BF',
        'title_heading': '#63ACDE',
        'border': '#019D8C',
        'photo_border': '#019D8C',
        'insidebackground_color': '#828282'
      },
    },
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Account: {
      set (value) {
        store.commit('setAccount', value);
      },
      get () {
        return store.state.Account;
      }
    },
    TemplateArray: {
      set (value) {
        store.commit('setTemplateArray', value);
      },
      get () {
        return store.state.TemplateArray;
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      this.$refs.tabs.onResize();
    });
  },
  async created () {
    this.templateId = this.$route.params.templateId;
    if (this.TemplateArray[this.templateId]) {
      this.templateItem = this.TemplateArray[this.templateId];
      if (this.Account.template && this.Account.template.style !== undefined) {
        this.templateItem.style = this.Account.template.style;
      }
      if (this.templateItem.style === undefined) {
        this.templateItem.style = this.defaultTemplateItem.style;
      }
      setTimeout(() => { this.resizeDoc() }, 3000);
    } else {
      await this.loadTemplate();
      setTimeout(() => { this.resizeDoc() }, 3000);

    }
    this.setIndexes();
    window.getApp.$emit('pageSubHeader', this.templateItem.name);
    this.largeImagename = 'Page 1';
    this.largeImagesrc = 'static/flipbookPages/FB2.jpg';
  },
  mounted () {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    resizeDoc () {
      this.$refs.tabs.onResize();
    },
    async loadTemplate () {
      let { error, data } = await getOne('Template', this.templateId);
      if (error) {
        console.log(error);
      } else {
        this.templateItem = data;
        this.TemplateArray[this.templateId] = this.templateItem;
        if (this.Account.template && this.Account.template.style !== undefined) {
          this.templateItem.style = this.Account.template.style;
        }
        if (this.templateItem.style === undefined) {
          this.templateItem.style = this.defaultTemplateItem.style;
        }
      }
    },
    setIndexes () {
      this.slideIndex = this.templateItem.page.findIndex((item) => {
        return item._id === this.templateItem.default_page._id;
      });
      // if (this.Account.template && this.Account.template.style && this.Account.template.template.id === this.templateId) {
      //   this.colorIndex = this.templateItem.style.findIndex((item) => {
      //     return item._id === this.Account.template.style;
      //   });
      // }
    },
    backToListing () {
      window.getApp.$emit('pageSubHeader', '');
      if (this.Account.template && this.Account.template.template) {
        this.$router.push({ 'path': '/dashboard' });
      } else {
        this.$router.push({ 'path': '/templates' });
      }
    },
    stripTags (string) {
      let tmp = document.createElement('DIV');
      tmp.innerHTML = string;
      return tmp.textContent || tmp.innerText || '';
    },
    async saveTemplate () {
      let tempStyle = this.templateItem.style;
      delete tempStyle._id;
      this.Account.template = {
        template: this.templateItem,
        style: tempStyle
      };
      this.Account.updated_from = 'template';
      let { error, data, status } = await update('Account', this.Account, session.getSession().adminUser ? session.getSession().user.human.account.id : 'Me');
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to update to update the template'
        };
      } else {
        // Create the timeline
        let timelineData = {
          title: 'Template Selected',
          text: `You've selected the template '${this.templateItem.name}'`,
          account: session.getSession().user.human.account.id
        };
        let { error, data, status } = await create('Timeline', timelineData);
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'orange',
            text: 'Failed to create the timeline'
          };
        } else {
          swal.fire({
            type: 'success',
            title: 'You have successfully selected your template',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              window.getApp.$emit('pageSubHeader', '');
              this.$router.push({ 'path': '/dashboard' });
            }
          });
        }
      }
    },
    handleResize () {
      const slideWidth = this.$refs.slideBox.$el.clientWidth;
      this.slideHeight = slideWidth * 0.62;
    },
    selectImage (themes, index) {
      this.largeImagename = themes.name;
      this.largeImagesrc = themes.src;
      this.activePage = index;
    },
    colorSelect (index) { // By default first card should selected so colorIndex = 0 is the default value.
      this.colorIndex = index;
      this.dataChanged = true;
    },
    colorSelectDailog (src) {
      this.dialog = true;
      this.DialogImg = src;
    },
    cancelSelect () {
      this.colorIndex = 0;
      this.$router.push({ path: '/templates' });
    },
    slideChange (index) {
      this.slideIndex = index;
    },
    changePrimaryColor (newColor) {
      this.templateItem.style.front_cover = newColor.hex;
    },
    changeBackgroundColor (newColor) {
      this.templateItem.style.background_cover = newColor.hex;
    },
    changeHeadingColor (newColor) {
      this.templateItem.style.title_heading = newColor.hex;
    },
    changeBorderColor (newColor) {
      this.templateItem.style.border = newColor.hex;
    },
    changeinsideBackgroundColor (newColor) {
      this.templateItem.style.insidebackground_color = newColor.hex;
    },
    changeBorderAroundColor (newColor) {
      this.templateItem.style.photo_border = newColor.hex;
    },
    resetSelect () {
      swal.fire({
        title: 'Reset template!',
        text: 'Do you wish to reset the template?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          (async () => {
            let entity = `Account`;
            this.Account.updated_from = 'template';
            this.Account.template = {};
            let { error, data, status } = await update(entity, this.Account, session.getSession().adminUser ? session.getSession().user.human.account.id : 'Me');
            if (error) {
              console.log('error', error);
            } else {
              // Create the timeline
              let timelineData = {
                title: 'Template Deselected',
                text: `You've deselected the template '${this.templateItem.name}'`,
                account: session.getSession().user.human.account.id
              };
              let { error, data, status } = await create('Timeline', timelineData);
              if (error) {
                console.log('error', error);
                this.snackbar = {
                  show: true,
                  color: 'orange',
                  text: 'Failed to create the timeline'
                };
              } else {
                swal.fire({
                  type: 'success',
                  title: 'Your template was deselected',
                  showConfirmButton: false,
                  timer: 2500,
                  onClose: () => {
                    window.getApp.$emit('pageSubHeader', '');
                    this.$router.push({ path: '/templates' });
                  }
                });
              }
            }
          })();
        }
      });
    }
  },
};
</script>
<style scoped>
.default_border {
  border: 5px solid transparent;
}
.default_border.selected_border {
  border-color: #7ac142;
}
.fixed-height-100 {
  white-space:nowrap; 
  overflow-x: auto;
}
.profile-view {
    margin-left: 110px;
    font-size: 16px;
    font-style: oblique;
    margin-left:50px;
}
.bg-color {
  color: #fff !important;
}
.v-tabs__div {
  max-width: 100px;
}
#themeDetail >>> .v-carousel__prev .v-btn .v-btn__content .v-icon {
  color: #7ac142 !important;
}
#themeDetail >>> .v-carousel__next .v-btn .v-btn__content .v-icon {
  color: #7ac142 !important;
}
#themeDetail >>> .slide-box .v-image__image.v-image__image--cover {
  background-size: contain!important;
}
#themeDetail .image_class {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 250px;
}
#themeDetail .button_background {
  background-color: #019D8C !important;
}
#themeDetail .color_ideas {
  color: #019D8C !important;
}
#themeDetail .picker_button {
  height: 25px !important;
}
#themeDetail .filler_icon {
  background-color: #E5E5E5 !important;
}
/* #themeDetail .vc-chrome {
  width:180px !important;
} */
#themeDetail .left_icon {
  position: absolute;
  left:0px
}
#themeDetail .mid_heading {
  position:absolute;
  left:25px;
}
#themeDetail .right_icon {
  position:absolute;
  right:0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Template/view.vue